/* eslint-disable func-names, max-len, no-new, no-plusplus, no-underscore-dangle */
import 'jquery';
import 'fancybox-core';
import 'fancybox-media';

let ko = {};

class MediaCentre {
  constructor(container) {
    this.container = container;

    this.$area = $('.filterArea', this.container);
    this.$filterBtn = $('.filterBtn', this.container);
    this.$isotopeContainer = $('.isotope-container', this.container);
    this.$videoPath = $('.js-media-video-path', this.container);
    this.videoPath = this.$videoPath.val();
    this.$newsPath = $('.js-media-news-path', this.container);
    this.newsPath = this.$newsPath.val();
    this.$cultureCode = $('.js-culture-code');
    this.cultureCode = this.$cultureCode.val();

    this.settings = {
      pageSize: 24,
    };

    this.model = {
      pageNumber: 1,
      categories: [],
      items: ko.observableArray(),
      totalItems: 0,
      selectedType: ko.observable(''),
    };

    this.$filterBtn.click(() => {
      this.$area.slideToggle();
    });

    this.model.canLoadMore = ko.computed(() => this.model.totalItems > this.model.items().length);

    // load items via ajax, append to items array
    this.model.loadMore = () => {
      this.model.pageNumber += 1;
      this.rebindList();
    };

    this.model.filter = category => {
      this.model.items.removeAll();
      this.model.selectedType(category);
      this.model.pageNumber = 1;
      this.rebindList();
    };

    const data = {
      path: this.videoPath,
      newsPath: this.newsPath,
      cultureCode: this.cultureCode
    };

    this.getMediaCategories(data).then(res => {
      this.model.categories = ko.mapping.fromJS(res.d.Data);
      this.model.categories.unshift('');
      this.rebindList();
    });
  }
  applyBindings() {
    ko.cleanNode(this.container);
    ko.applyBindings(this.model, this.container);
  }
  getMediaCategories(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/sitefiles/webservices/media.asmx/GetMediaCategories',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: res => resolve(res),
        error: err => reject(err),
      });
    });
  }
  getMediaItems(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/sitefiles/webservices/media.asmx/GetMediaItems',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: res => resolve(res),
        error: err => reject(err),
      });
    });
  }
  rebindList() {
    const data = {
      pageSize: this.settings.pageSize,
      pageNumber: this.model.pageNumber,
      selectedType: this.model.selectedType(),
      path: this.videoPath,
      newsPath: this.newsPath,
      cultureCode: this.cultureCode
    };

    this.getMediaItems(data).then(res => {
      this.$isotopeContainer.removeClass('isotope-active');
      ko.utils.arrayPushAll(this.model.items, res.d.Data.items);
      setTimeout(this.applyBindings.bind(this), 100);
    });
  }
}

$(window).load(() => {
  const $mediaCentre = $('#milwaukee-media-centre');

  if ($mediaCentre.length > 0) {
    require.ensure(['knockout'], require => {
      ko = require('knockout');
      require('knockout-mapping');
      require('../../bindings/ko-fancybox');
      require('../../bindings/ko-isotope');
      $mediaCentre.each((i, item) => new MediaCentre(item));
    });
  }
});
